export enum AssetPref {
	CHECKSUM_ENABLED = 'metadata.checksumEnabled',
}

export enum AssetImagePref {
	THUMB_MAX_LENGTH = 'image.thumb_max_length',
	PREVIEW_MAX_LENGTH = 'image.preview_max_length',
	ZOOM_MAX_LENGTH = 'image.zoom_max_length',
}

export const AudioFormatFamilyType = <const>{
	AUDIO: 'audio',
};
export const AudioFormatFamilies = Object.values(AudioFormatFamilyType);

export const DocumentFormatFamilyType = <const>{
	DOCUMENT: 'document',
	LAYOUT: 'layout',
};
export const DocumentFormatFamilies = Object.values(DocumentFormatFamilyType);

export const ImageFormatFamilyType = <const>{
	CAMERA_RAW: 'cameraRaw',
	IMAGE: 'image',
	RAW: 'raw',
	VECTOR: 'vector',
};
export const ImageFormatFamilies = Object.values(ImageFormatFamilyType);

export const VideoFormatFamilyType = <const>{
	VIDEO: 'video',
};
export const VideoFormatFamilies = Object.values(VideoFormatFamilyType);

export const MediaFormatFamilyType = <const>{
	...AudioFormatFamilyType,
	...VideoFormatFamilyType,
};
export const MediaFormatFamilies = Object.values(MediaFormatFamilyType);
